webpackJsonp([35783957827783],{

/***/ 91:
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ }),

/***/ 113:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB3aWR0aD0iMTc5MiIgaGVpZ2h0PSIxNzkyIiB2aWV3Qm94PSIwIDAgMTc5MiAxNzkyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0xNDA4IDkyOHYzMjBxMCAxMTktODQuNSAyMDMuNXQtMjAzLjUgODQuNWgtODMycS0xMTkgMC0yMDMuNS04NC41dC04NC41LTIwMy41di04MzJxMC0xMTkgODQuNS0yMDMuNXQyMDMuNS04NC41aDcwNHExNCAwIDIzIDl0OSAyM3Y2NHEwIDE0LTkgMjN0LTIzIDloLTcwNHEtNjYgMC0xMTMgNDd0LTQ3IDExM3Y4MzJxMCA2NiA0NyAxMTN0MTEzIDQ3aDgzMnE2NiAwIDExMy00N3Q0Ny0xMTN2LTMyMHEwLTE0IDktMjN0MjMtOWg2NHExNCAwIDIzIDl0OSAyM3ptMzg0LTg2NHY1MTJxMCAyNi0xOSA0NXQtNDUgMTktNDUtMTlsLTE3Ni0xNzYtNjUyIDY1MnEtMTAgMTAtMjMgMTB0LTIzLTEwbC0xMTQtMTE0cS0xMC0xMC0xMC0yM3QxMC0yM2w2NTItNjUyLTE3Ni0xNzZxLTE5LTE5LTE5LTQ1dDE5LTQ1IDQ1LTE5aDUxMnEyNiAwIDQ1IDE5dDE5IDQ1eiIgZmlsbD0iI2ZmZiIvPjwvc3ZnPg=="

/***/ }),

/***/ 114:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB3aWR0aD0iMTc5MiIgaGVpZ2h0PSIxNzkyIiB2aWV3Qm94PSIwIDAgMTc5MiAxNzkyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0xMzQzIDEydjI2NGgtMTU3cS04NiAwLTExNiAzNnQtMzAgMTA4djE4OWgyOTNsLTM5IDI5NmgtMjU0djc1OWgtMzA2di03NTloLTI1NXYtMjk2aDI1NXYtMjE4cTAtMTg2IDEwNC0yODguNXQyNzctMTAyLjVxMTQ3IDAgMjI4IDEyeiIgZmlsbD0iIzFCMjUzMyIvPjwvc3ZnPgo="

/***/ }),

/***/ 115:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB3aWR0aD0iMTc5MiIgaGVpZ2h0PSIxNzkyIiB2aWV3Qm94PSIwIDAgMTc5MiAxNzkyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik00NzcgNjI1djk5MWgtMzMwdi05OTFoMzMwem0yMS0zMDZxMSA3My01MC41IDEyMnQtMTM1LjUgNDloLTJxLTgyIDAtMTMyLTQ5dC01MC0xMjJxMC03NCA1MS41LTEyMi41dDEzNC41LTQ4LjUgMTMzIDQ4LjUgNTEgMTIyLjV6bTExNjYgNzI5djU2OGgtMzI5di01MzBxMC0xMDUtNDAuNS0xNjQuNXQtMTI2LjUtNTkuNXEtNjMgMC0xMDUuNSAzNC41dC02My41IDg1LjVxLTExIDMwLTExIDgxdjU1M2gtMzI5cTItMzk5IDItNjQ3dC0xLTI5NmwtMS00OGgzMjl2MTQ0aC0ycTIwLTMyIDQxLTU2dDU2LjUtNTIgODctNDMuNSAxMTQuNS0xNS41cTE3MSAwIDI3NSAxMTMuNXQxMDQgMzMyLjV6IiBmaWxsPSIjMUIyNTMzIi8+PC9zdmc+"

/***/ }),

/***/ 116:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB3aWR0aD0iMTc5MiIgaGVpZ2h0PSIxNzkyIiB2aWV3Qm94PSIwIDAgMTc5MiAxNzkyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0xNjg0IDQwOHEtNjcgOTgtMTYyIDE2NyAxIDE0IDEgNDIgMCAxMzAtMzggMjU5LjV0LTExNS41IDI0OC41LTE4NC41IDIxMC41LTI1OCAxNDYtMzIzIDU0LjVxLTI3MSAwLTQ5Ni0xNDUgMzUgNCA3OCA0IDIyNSAwIDQwMS0xMzgtMTA1LTItMTg4LTY0LjV0LTExNC0xNTkuNXEzMyA1IDYxIDUgNDMgMCA4NS0xMS0xMTItMjMtMTg1LjUtMTExLjV0LTczLjUtMjA1LjV2LTRxNjggMzggMTQ2IDQxLTY2LTQ0LTEwNS0xMTV0LTM5LTE1NHEwLTg4IDQ0LTE2MyAxMjEgMTQ5IDI5NC41IDIzOC41dDM3MS41IDk5LjVxLTgtMzgtOC03NCAwLTEzNCA5NC41LTIyOC41dDIyOC41LTk0LjVxMTQwIDAgMjM2IDEwMiAxMDktMjEgMjA1LTc4LTM3IDExNS0xNDIgMTc4IDkzLTEwIDE4Ni01MHoiIGZpbGw9IiMxQjI1MzMiLz48L3N2Zz4="

/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/admin-home-page.634a38c8.png";

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/intelllex-reversed-logo.9b8ea1e2.png";

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _intelllexReversedLogo = __webpack_require__(47);
	
	var _intelllexReversedLogo2 = _interopRequireDefault(_intelllexReversedLogo);
	
	var _facebook = __webpack_require__(114);
	
	var _facebook2 = _interopRequireDefault(_facebook);
	
	var _twitter = __webpack_require__(116);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	var _linkedin = __webpack_require__(115);
	
	var _linkedin2 = _interopRequireDefault(_linkedin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    'footer',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'footer__flex-box' },
	      _react2.default.createElement(
	        'div',
	        { className: 'footer__logo' },
	        _react2.default.createElement('img', { src: _intelllexReversedLogo2.default })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'footer__content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 col-md' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'a',
	                { className: 'link', href: 'https://intelllex.com/' },
	                'Products & Services'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'a',
	                { className: 'link', href: 'https://intelllex.com/company' },
	                'Meet the team'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 col-md' },
	            _react2.default.createElement(
	              'div',
	              { className: 'text-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title-text' },
	                'Contact Us'
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                'For support issues: ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'mailto:support@intelllex.com' },
	                  'support@intelllex.com'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                'Contact sales: ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'mailto:contact@intelllex.com' },
	                  'contact@intelllex.com'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'text-block' },
	              _react2.default.createElement(
	                'div',
	                null,
	                '276A South Bridge Rd,'
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                'Singapore 058825'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 col-md' },
	            _react2.default.createElement(
	              'div',
	              { className: 'text-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title-text' },
	                'Connect with us'
	              ),
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.facebook.com/intelllex/', target: '_blank', className: 'social-icon-link' },
	                _react2.default.createElement('img', { className: 'social-icon', src: _facebook2.default })
	              ),
	              _react2.default.createElement(
	                'a',
	                { href: 'https://sg.linkedin.com/company/intelllex', target: '_blank', className: 'social-icon-link' },
	                _react2.default.createElement('img', { className: 'social-icon', src: _linkedin2.default })
	              ),
	              _react2.default.createElement(
	                'a',
	                { href: 'https://twitter.com/intelllexhq', target: '_blank', className: 'social-icon-link' },
	                _react2.default.createElement('img', { className: 'social-icon', src: _twitter2.default })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'ie-brand' },
	            '\xA9 INTELLLEX'
	          ),
	          '\xA0\xA0',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://intelllex.com/privacy', target: '_blank' },
	            'Privacy'
	          ),
	          '\xA0\xA0|\xA0\xA0',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://intelllex.com/terms', target: '_blank' },
	            'Terms'
	          )
	        )
	      ),
	      _react2.default.createElement('div', { className: 'footer__logo' })
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _intelllexReversedLogo = __webpack_require__(47);
	
	var _intelllexReversedLogo2 = _interopRequireDefault(_intelllexReversedLogo);
	
	var _externalLink = __webpack_require__(113);
	
	var _externalLink2 = _interopRequireDefault(_externalLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(_ref) {
	  var tall = _ref.tall;
	  return _react2.default.createElement(
	    'div',
	    { className: 'header' },
	    _react2.default.createElement(
	      'div',
	      { className: 'header-row' },
	      _react2.default.createElement(
	        'span',
	        { className: 'logo-group' },
	        _react2.default.createElement('img', { src: _intelllexReversedLogo2.default, className: 'logo' }),
	        _react2.default.createElement(
	          'span',
	          null,
	          'INTELLLEX'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        { className: 'support' },
	        'SUPPORT'
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'https://intelllex.com', className: 'intlx-link' },
	        _react2.default.createElement('img', { src: _externalLink2.default }),
	        'Back to INTELLLEX'
	      )
	    ),
	    tall && _react2.default.createElement(
	      'h1',
	      { className: 'caption' },
	      'Get more out of INTELLLEX'
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SectionLink = function (_PureComponent) {
	  _inherits(SectionLink, _PureComponent);
	
	  function SectionLink() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SectionLink);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.onClick = function () {
	      var el = document.getElementById(_this.props.scrollTo);
	      el && el.scrollIntoView();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  SectionLink.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "section-nav-item", onClick: this.onClick },
	      this.props.name
	    );
	  };
	
	  return SectionLink;
	}(_react.PureComponent);
	
	exports.default = SectionLink;
	module.exports = exports["default"];

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(145);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Header = __webpack_require__(67);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(66);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _SectionLink = __webpack_require__(68);
	
	var _SectionLink2 = _interopRequireDefault(_SectionLink);
	
	var _adminHomePage = __webpack_require__(430);
	
	var _adminHomePage2 = _interopRequireDefault(_adminHomePage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sections = [{
	  name: 'SOURCE+ precise and aggregated search',
	  id: 'using-source',
	  description: _react2.default.createElement(
	    'span',
	    null,
	    _react2.default.createElement(
	      'p',
	      null,
	      'SOURCE+ is an intelligent legal search engine that understands legal concepts and their relevance to Cases, Commentaries and Court Submissions*. It helps you find pertinent information quickly and efficiently across several Commonwealth jurisdictions.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '*Submissions from High Court of Australia will be available in the basic plan for a limited period with Legislation & Regulations coming soon.'
	    )
	  ),
	  contents: [{ name: 'SOURCE+ Content Coverage', path: '/source/source-coverage' }, { name: 'Refine Your Search (Boolean Guide)', path: '/source/refine-your-search' }]
	}, {
	  name: 'STACKS - knowledge library for your firm',
	  id: 'using-stacks',
	  description: _react2.default.createElement(
	    'span',
	    null,
	    _react2.default.createElement(
	      'p',
	      null,
	      'Tired of navigating through a maze of folders to find a previous precedent or earlier research? Forgot how you named your folder?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'STACKS is your law firm\u2019s ',
	      _react2.default.createElement(
	        'b',
	        null,
	        'knowledge library'
	      ),
	      ', where your work documents and legal research from different sources such as personal precedents, search result links, submissions and office memorandums, can be consolidated and organised intelligently.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Our AI technology automatically recommends ',
	      _react2.default.createElement(
	        'b',
	        null,
	        'Categories'
	      ),
	      ' to classify your documents which are synced and uploaded to INTELLLEX according to their legal topic and document type. Get organised from the get-go, so that future retrieval will be a cinch.'
	    )
	  ),
	  contents: [{ name: 'Sync or Upload Your Folders and Files', path: '/stacks/sync-or-upload-your-folders-and-files' }, { name: 'Organise your STACKS', path: '/stacks/organise-your-stacks' }, { name: 'Search in STACKS', path: '/stacks/search-in-stacks' }, { name: 'Share and Request for Access', path: '/stacks/share-and-request-for-access' }]
	}, {
	  name: 'Workspace Administration',
	  id: 'using-admin',
	  description: _react2.default.createElement(
	    'span',
	    null,
	    _react2.default.createElement(
	      'p',
	      null,
	      'As a Workspace Admin, you are critical to the success of your organisation through effective management of your firm\u2019s knowledge library and the optimal use of INTELLLEX.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To assist you, we have built tools to help you manage user, Categories and view activity logs. Only Admins will have access to these features under the Admin section.'
	    )
	  ),
	  contents: [{ name: 'Categories Management', path: '/admin/categories-management' }],
	  thumbnail: _adminHomePage2.default
	}, {
	  name: 'Contact Us',
	  id: 'contact-us',
	  contents: []
	}];
	
	var ContentLint = function ContentLint(_ref) {
	  var name = _ref.name,
	      path = _ref.path;
	  return _react2.default.createElement(
	    _gatsbyLink2.default,
	    { to: path },
	    name
	  );
	};
	
	var Section = function Section(_ref2) {
	  var id = _ref2.id,
	      name = _ref2.name,
	      description = _ref2.description,
	      contents = _ref2.contents,
	      thumbnail = _ref2.thumbnail;
	  return _react2.default.createElement(
	    'div',
	    { id: id, className: 'catalog-section-container' },
	    _react2.default.createElement(
	      'h1',
	      null,
	      name
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'description' },
	      description
	    ),
	    thumbnail && _react2.default.createElement(
	      'div',
	      { className: 'thumbnail' },
	      _react2.default.createElement('img', { src: thumbnail, alt: name })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      contents.map(function (_ref3) {
	        var name = _ref3.name,
	            path = _ref3.path;
	        return _react2.default.createElement(
	          'div',
	          { className: 'col-12 col-md-6 content-link-container', key: path },
	          _react2.default.createElement(ContentLint, { name: name, path: path })
	        );
	      })
	    )
	  );
	};
	
	var ContactUs = function ContactUs(_ref4) {
	  var id = _ref4.id,
	      name = _ref4.name;
	  return _react2.default.createElement(
	    'div',
	    { id: id, className: 'catalog-section-container' },
	    _react2.default.createElement(
	      'h1',
	      null,
	      name
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Experiencing an issue on INTELLLEX? Let us know how we can help.'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'a',
	      { className: 'button blue-face', href: 'mailto:support@intelllex.com' },
	      'Email us'
	    )
	  );
	};
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Header2.default, { tall: true }),
	    _react2.default.createElement(
	      'div',
	      { className: 'container main-page-container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 col-md-3' },
	          sections.map(function (_ref5) {
	            var name = _ref5.name,
	                id = _ref5.id;
	            return _react2.default.createElement(_SectionLink2.default, { key: id, name: name, scrollTo: id });
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 col-md-9', id: 'catalog-index' },
	          sections.map(function (_ref6) {
	            var id = _ref6.id,
	                name = _ref6.name,
	                contents = _ref6.contents,
	                description = _ref6.description,
	                thumbnail = _ref6.thumbnail;
	            return id !== 'contact-us' ? _react2.default.createElement(Section, { key: id, id: id, name: name, contents: contents, description: description, thumbnail: thumbnail }) : _react2.default.createElement(ContactUs, { key: id, id: id, name: name });
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-1ff04bb287eefccf1a35.js